import {Component, Input, OnInit} from '@angular/core';
import {FormControlName, UntypedFormControl, UntypedFormGroup, FormBuilder} from '@angular/forms';

@Component({
  selector: 'app-singleline-text-field',
  templateUrl: './singleline-text-field.component.html',
  styleUrls: ['./singleline-text-field.component.scss'],
})
export class SinglelineTextFieldComponent implements OnInit {
  @Input() label: string;
  @Input() inputName: string;
  @Input() form: UntypedFormGroup;
  @Input() isError: boolean;
  @Input() preValue: string;
  @Input() disabled = false;
  @Input() requiredField: boolean = false;

  constructor(
    public fb: FormBuilder
  ) { }

  ngOnInit() {
    if (this.preValue && this.form && this.inputName) {
      this.form.get(this.inputName)?.setValue(this.preValue);
      if (this.disabled) {
        this.form.get(this.inputName)?.disable();
      }
    }
  };
}
